var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoMapCenter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 500,
    viewBox: "0 0 500 500",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50 310C61.0457 310 70 318.954 70 330V420C70 425.523 74.4772 430 80 430H170C181.046 430 190 438.954 190 450V470C190 481.046 181.046 490 170 490H80C41.3401 490 10 458.66 10 420V330C10 318.954 18.9543 310 30 310H50ZM190 50C190 61.0457 181.046 70 170 70H80C74.4771 70 70 74.4772 70 80V170C70 181.046 61.0457 190 50 190H30C18.9543 190 10 181.046 10 170V80C10 41.3401 41.3401 10 80 10H170C181.046 10 190 18.9543 190 30V50ZM450 190C438.954 190 430 181.046 430 170V80C430 74.4771 425.523 70 420 70H330C318.954 70 310 61.0457 310 50V30C310 18.9543 318.954 10 330 10H420C458.66 10 490 41.3401 490 80V170C490 181.046 481.046 190 470 190H450ZM310 450C310 438.954 318.954 430 330 430H420C425.523 430 430 425.523 430 420V330C430 318.954 438.954 310 450 310H470C481.046 310 490 318.954 490 330V420C490 458.66 458.66 490 420 490H330C318.954 490 310 481.046 310 470V450Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoMapCenter);
export default __webpack_public_path__ + "static/media/ico_map_center.86f2824eb02e8511086b45457ee14907.svg";
export { ForwardRef as ReactComponent };